/**
 * Helper-Funktionen für die Übersetzung von Backend-Enums ins Deutsche
 */

/**
 * Übersetzt eine Role vom Backend (Englisch) ins Deutsche
 * @param {string} role - Die englische Rolle vom Backend (z.B. "ADMIN", "YOUTH_LEADER")
 * @returns {string} Die deutsche Übersetzung der Rolle
 */
export const translateRole = (role) => {
    const translations = {
        'ADMIN': 'Administrator',
        'DISTRICT_YOUTH_LEADER': 'Kreisjugendwart',
        'YOUTH_LEADER': 'Jugendwart',
        'SUPERVISOR': 'Betreuer',
        'GUEST': 'Gast'
    };

    return translations[role] || role;
};

/**
 * Gibt alle verfügbaren Rollen mit deutscher Übersetzung zurück
 * @returns {Array<{value: string, label: string}>} Array mit Rollen-Objekten
 */
export const getRoleOptions = () => {
    return [
        {value: 'ADMIN', label: 'Administrator'},
        {value: 'DISTRICT_YOUTH_LEADER', label: 'Kreisjugendwart'},
        {value: 'YOUTH_LEADER', label: 'Jugendwart'},
        {value: 'SUPERVISOR', label: 'Betreuer'},
        {value: 'GUEST', label: 'Gast'}
    ];
};

